// src/pages/actividades/components/agenda/AgendaUnscheduled.tsx
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import type { ActividadListItem, AreaActividad } from '@/types';

interface Props {
  activities: ActividadListItem[];
  maxHeight?: number;
}

const CHIP_COLORS: Record<AreaActividad | 'default', string> = {
  TRABAJO: 'bg-blue-100 text-blue-800 border-blue-200',
  ADMINISTRATIVO: 'bg-amber-100 text-amber-800 border-amber-200',
  PERSONAL: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  default: 'bg-gray-100 text-gray-700 border-gray-200',
};

export function AgendaUnscheduled({ activities, maxHeight = 80 }: Props) {
  const navigate = useNavigate();

  if (activities.length === 0) return null;

  return (
    <div className="border-b bg-muted/30 px-3 py-2">
      <div className="flex items-center gap-2 mb-1">
        <span className="text-xs font-medium text-muted-foreground">
          Sin hora ({activities.length})
        </span>
      </div>
      <div
        className="flex flex-wrap gap-1 overflow-y-auto"
        style={{ maxHeight: `${maxHeight}px` }}
      >
        {activities.map((act) => {
          const colorKey = (CHIP_COLORS[act.area] ? act.area : 'default') as AreaActividad | 'default';
          const isCompleted = act.estado === 'COMPLETADA' || act.estado === 'CANCELADA';
          return (
            <button
              key={act.id}
              type="button"
              onClick={() => navigate(`/actividades/${act.id}`)}
              className={cn(
                'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium',
                'hover:shadow-sm cursor-pointer transition-shadow truncate max-w-[200px]',
                CHIP_COLORS[colorKey],
                isCompleted && 'opacity-50 line-through'
              )}
              title={act.titulo}
            >
              {act.titulo}
            </button>
          );
        })}
      </div>
    </div>
  );
}
